export enum ClientSideSecrets {
  FB_API_KEY = "FB_API_KEY",
  FB_VAPID_KEY = "FB_VAPID_KEY",
}
